import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-validity-format',
  templateUrl: './validity-format.component.html',
  styleUrls: ['./validity-format.component.css']
})
export class ValidityFormatComponent implements OnInit {
@Input() validityType: any;
  constructor() { }

  ngOnInit() {
  }

}
